import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import React from "react";
import WrapperContainer from "./WrapperContainer";
import { ResponsiveStyles } from "./responsiveDimension";
import FaceBookSvg from "../../assets/svg/FacebookSvg";
import InstagramSvg from "../../assets/svg/InstagramSvg";
import LinkedinSvg from "../../assets/svg/LinkedinSvg";
import YoutubeSvg from "../../assets/svg/youtube";
import Twittersvg from "../../assets/svg/TwitterSvg";
import { useNavigate } from "react-router-dom";
import { RoutesPath } from "../../routes/RoutesPath";
import { policyData } from "../../data/policyData";

const Footer = () => {
  const navigate = useNavigate();

  const Heading = ({ title }) => {
    return (
      <Typography fontSize={16} fontWeight={700} color="white">
        {title}
      </Typography>
    );
  };
  // const Text = ({ title, subTitle }) => {
  //   return (
  //     <TextName>
  //       {subTitle && <span style={{ fontWeight: 700 }}>{subTitle} : </span>}
  //       {title}
  //     </TextName>
  //   );
  // };

  const Text = ({ title, subTitle, onClick }) => {
    return (
      <TextName
        onClick={onClick}
        style={{ cursor: onClick ? "pointer" : "default" }}
      >
        {subTitle && <span style={{ fontWeight: 700 }}>{subTitle} : </span>}
        {title}
      </TextName>
    );
  };
  const serviceslist = [
    { name: "AI Engineering" },
    { name: "App Development" },
    { name: "UI/UX Design" },
    { name: "Data Analytics" },
    { name: "Website Development" },
  ];

  const linkslist = [
    { name: "Home", navigate: "/" },
    { name: "Services" },
    { name: "About Us" },
    { name: "Contact Us", navigate: RoutesPath.ContactUs },
    { name: "Careers", navigate: RoutesPath.CAREERS },
  ];
  const contactDetails = [
    {
      type: "Address",
      value:
        "11/54 J, Tenkasi Road, 7th Street, Alangulam, Tirunelveli, Tamil Nadu – 627851",
    },
    {
      type: "Email",
      value: "hello@jseven.in",
    },
    {
      type: "Phone",
      value: "04633 291912",
    },
    // {
    //   type: "Fax",
    //   value: "+91 9123561257",
    // },
  ];

  const socialmediaIcons = [
    FaceBookSvg,
    InstagramSvg,
    Twittersvg,
    LinkedinSvg,
    YoutubeSvg,
  ];
  const policy = policyData;

  return (
    <Container>
      <WrapperContainer>
        <SubContainer>
          <ContentContainer>
            <Heading title={"Follow Us"} />
            <Text
              title={
                "Even if we had a clear definition of company culture, there is no recipe book to follow for producing the kind of company culture you want."
              }
            />
            <IconsContainer>
              {socialmediaIcons.map((Value, index) => (
                <SvgIcon key={index}>
                  <Value width={20} height={20} color={"black"} />
                </SvgIcon>
              ))}
            </IconsContainer>
          </ContentContainer>
          <ContentContainer>
            <Heading title={"Services"} />
            {serviceslist.map((service, index) => (
              <Text key={index} title={service.name} />
            ))}
          </ContentContainer>
          <ContentContainer>
            <Heading title={"Links"} />
            {linkslist.map((link, index) => (
              <Text
                key={index}
                title={link.name}
                onClick={
                  link.navigate ? () => navigate(link.navigate) : undefined
                }
              />
            ))}
          </ContentContainer>
          <ContentContainer>
            <Heading title={"Policy"} />
            {policy?.map((data, index) => (
              <TextName
                key={index}
                onClick={() =>
                  navigate(`/policy/${data.route}`, {
                    state: { content: data.content },
                  })
                }
              >
                {data.name} {/* Or any content you want to display */}
              </TextName>
            ))}
          </ContentContainer>

          <ContentContainer>
            <Heading title={"Contact us"} />
            {contactDetails.map((link, index) => (
              <Text key={index} title={link.value} subTitle={link.type} />
            ))}
          </ContentContainer>
        </SubContainer>
      </WrapperContainer>
      <AllRights>
        © 2025 Copyright by J7 Technology Solutions Pvt Ltd. All rights
        reserved.
      </AllRights>
    </Container>
  );
};

const Container = styled(Box)(() => ({
  backgroundColor: "black",
  padding: "50px 0px",
}));
const SubContainer = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
}));
const AllRights = styled(Typography)(() => ({
  textAlign: "center",
  width: "100%",
  color: "white",
  borderTop: "1px solid white",
  paddingTop: 20,
  marginTop: 20,
}));
const ContentContainer = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "column",
  gap: 10,
  padding: 10,
  ...ResponsiveStyles({
    width: {
      xs: "100%",
      md: "50%",
      lg: "20%",
    },
  }),
}));

const IconsContainer = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  gap: 10,
}));
const TextName = styled(Box)(() => ({
  fontSize: 16,
  fontWeight: 400,
  color: "white",
  cursor: "pointer",
}));

const SvgIcon = styled(Box)(() => ({
  backgroundColor: "white",
  width: 40,
  height: 40,
  borderRadius: 50,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all .2s linear",
  cursor: "pointer",
  "&:hover": {
    transform: "scale(1.1)",
    transition: "all .2s linear",
  },
}));

export default Footer;
